import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "@mui/material";
import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import AddNote from "../../Modals/addNote";
import { isValidInput } from "../../utils/validations";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BookingDetailView = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };

  const goBack = () => {
    navigate(-1); // this goes one step back in history
  };

  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            Booking Detail
          </h1>
          <div className="right_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />

            <Button className="btn btn_primary">
              <img src="/static/images/filter_icon.svg" alt="icon" /> Filters
            </Button>
          </div>
        </div>

        <Box className="custom_tabs1 mb_30" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Booking Info" {...a11yProps(0)} />
            <Tab label="Notes" {...a11yProps(1)} />
          </Tabs>
        </Box>

        <AddNote open={open1} onClose={handleCloseModal1} setOpen={setOpen1} />
      </MainContainer>
    </>
  );
};

export default BookingDetailView;
